import React from 'react'
import { PageContextProvider } from 'pageContext'
import ApplicationAppRightsAssignments from './ApplicationAppRightsAssignment'
import ApplicationRoleDefinitionAssignments from './ApplicationRoleDefinitionAssignments'
import ApplicationAppRightsPeople from './AppRightsPeople'
import ApplicationRoleDefinitionPeople from './RoleDefinitionPeople'

const PbacAccessAssignments = ({
    subActiveTab,
    applicationId,
    resourceSystemModuleID,
    applicationFriendlyName,
    applicationType,
    resourceId,
}) => {
    const renderContent = () => {
        if (subActiveTab === 'appRightsAssignments') {
            return (
                <PageContextProvider key={'appRightsAssignments'}>
                    <ApplicationAppRightsAssignments
                        resourceSystemModuleID={resourceSystemModuleID}
                        resourceId={resourceId}
                        applicationType={applicationType}
                    />
                </PageContextProvider>
            )
        }
        if (subActiveTab === 'roleDefinitionAssignments') {
            return (
                <PageContextProvider key={'roleDefinitionAssignments'}>
                    <ApplicationRoleDefinitionAssignments
                        resourceId={resourceId}
                        resourceSystemModuleID={resourceSystemModuleID}
                        applicationType={applicationType}
                    />
                </PageContextProvider>
            )
        }
        if (subActiveTab === 'appRightsPeople') {
            return (
                <PageContextProvider key={'appRightsPeople'}>
                    <ApplicationAppRightsPeople
                        applicationId={applicationId}
                        applicationType={applicationType}
                        resourceId={resourceId}
                        resourceSystemModuleID={resourceSystemModuleID}
                        applicationFriendlyName={applicationFriendlyName}
                    />
                </PageContextProvider>
            )
        }
        if (subActiveTab === 'roleDefinitionPeople') {
            return (
                <PageContextProvider key={'roleDefinitionPeople'}>
                    <ApplicationRoleDefinitionPeople
                        applicationId={applicationId}
                        applicationFriendlyName={applicationFriendlyName}
                        applicationType={applicationType}
                        resourceId={resourceId}
                        resourceSystemModuleID={resourceSystemModuleID}
                    />
                </PageContextProvider>
            )
        }
        return <></>
    }
    return renderContent()
}

export default PbacAccessAssignments
